import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { SelectOption } from '@grupo-constant/next-dtype/types';
import { TranslocoService } from '@ngneat/transloco';
import { DialogsService } from '../dialogs.service';
import { FuseConfirmationService } from '../../../@fuse/services/confirmation/confirmation.service';
import { HttpService } from '../../core/http/http.service';
import { NextMethodsEnum } from '../../core/enums/next-methods.enum';

@Component({
    selector: 'new-tasktype-dialog',
    templateUrl: './new-tasktype-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class NewTaskTypeDataDialogComponent implements OnInit {

    tipologyOptions: SelectOption[];

    control: FormControl = new FormControl('', Validators.required);

    private readonly tipologyClass = 'com.cloudcodice.thirdparty.grupoconstant.nexttasktype.NextTaskTypeTypology';

    constructor(
        public dialogRef: MatDialogRef<NewTaskTypeDataDialogComponent>,
        private dialogsService: DialogsService,
        private _fuseConfirmationService: FuseConfirmationService,
        private httpService: HttpService,
        private transloco: TranslocoService,
    ) { }

    ngOnInit() {
        this.httpService.post<{ option: SelectOption[] }>(NextMethodsEnum.retrieveEnumerationType, { enumerationClass: this.tipologyClass })
            .subscribe(reply => this.tipologyOptions = reply.option);
    }

    getNewInstance() {
        const confirmDialog = this.openConfirmDialog();
        confirmDialog.afterClosed().subscribe((confirm) => {
            if (confirm === 'confirmed') {
                this.control.markAsTouched();
                if (this.control.valid) {
                    this.dialogRef.close(this.control.value);
                } else {
                    this.dialogsService.openErrorDialog({
                        message: this.transloco.translate('errorsInForm')
                    });
                }
            }
        });
    }

    closeDialog(icon?: string) {
        this.dialogRef.close(icon);
    }

    private openConfirmDialog() {
        return this._fuseConfirmationService.open({
            title: this.transloco.translate('tasktypeNewInstanceTitle'),
            message: this.transloco.translate('tasktypeNewInstanceMsg'),
            actions: {
                confirm: {
                    label: this.transloco.translate('confirm')
                },
                cancel: {
                    label: this.transloco.translate('cancel')
                }
            }
        });
    }

}
